import React from 'react';

const TargetIcon = ({ fill, className }) => {
  return (
    <svg
      width='29'
      height='29'
      viewBox='0 0 29 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0 14.5C0 6.45909 6.45909 0 14.5 0C22.5409 0 29 6.45909 29 14.5C29 22.5409 22.5409 29 14.5 29C6.45909 29 0 22.5409 0 14.5ZM2 14.5C2 21.4444 7.55556 27 14.5 27C21.4444 27 27 21.4444 27 14.5C27 7.55556 21.4444 2 14.5 2C7.55556 2 2 7.55556 2 14.5ZM14.5 5C9.20714 5 5 9.20714 5 14.5C5 19.7929 9.20714 24 14.5 24C19.7929 24 24 19.7929 24 14.5C24 9.20714 19.7929 5 14.5 5ZM7 14.5C7 18.7 10.3 22 14.5 22C18.7 22 22 18.7 22 14.5C22 10.3 18.7 7 14.5 7C10.3 7 7 10.3 7 14.5ZM14.5 10C11.95 10 10 11.95 10 14.5C10 17.05 11.95 19 14.5 19C17.05 19 19 17.05 19 14.5C19 11.95 17.05 10 14.5 10ZM12 14.5C12 16 13 17 14.5 17C16 17 17 16 17 14.5C17 13 16 12 14.5 12C13 12 12 13 12 14.5Z'
        fill={fill || 'white'}
      />
    </svg>
  );
};

export default TargetIcon;
